"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryItemsAlphabetic = exports.isEuropeanCountry = exports.getCountryCodeExtendedFromAddress = exports.getCountryCodesObject = exports.moveToTop = exports.getCountryCode = exports.getAllCoveredCountryItems = exports.getCountryItems = exports.getCountryCodes = exports.getCountryName = exports.getCountryAlpha2 = exports.getCountryGroup = exports.getCountryCodesForLocationsOrGroups = exports.getCountryIdsForLocationsOrGroups = exports.getCountryIdentifiersForLocationsOrGroups = exports.getCountry = exports.getCountryCodesForGroup = exports.getCountryIdsForGroup = exports.getCountryIdentifiersForGroup = exports.getCountriesForGroupEurope = exports.getCountriesForGroup = exports.getDefaultCountryCodes = exports.getAllCoveredCountriesEURatingEngine = exports.getAllCoveredCountries = exports.getAllCountryCodes = exports.getAllCountries = exports.postalRequired = exports.getCountryAlpha2FromAlpha3 = exports.eCountryGroupEuropeRatingEngine = exports.eCountryGroup = void 0;
const utils_1 = require("@loadsure/utils");
const country_class_1 = __importDefault(require("./country.class"));
const countries_json_1 = __importDefault(require("./countries.json"));
var eCountryGroup;
(function (eCountryGroup) {
    eCountryGroup["CONTINENTAL_UNITED_STATES_AND_CANADA"] = "CONTINENTAL_UNITED_STATES_AND_CANADA";
    eCountryGroup["EUROPE"] = "EUROPE";
    eCountryGroup["HAWAII_AND_CARIBBEAN"] = "HAWAII_AND_CARIBBEAN";
    eCountryGroup["FAR_EAST__ASIA_AND_AUSTRALIA"] = "FAR_EAST__ASIA_AND_AUSTRALIA";
    eCountryGroup["MIDDLE_EAST"] = "MIDDLE_EAST";
    eCountryGroup["OTHER"] = "OTHER";
    eCountryGroup["NOT_COVERED"] = "NOT_COVERED";
    eCountryGroup["SANCTIONED"] = "SANCTIONED";
})(eCountryGroup = exports.eCountryGroup || (exports.eCountryGroup = {}));
var eCountryGroupEuropeRatingEngine;
(function (eCountryGroupEuropeRatingEngine) {
    eCountryGroupEuropeRatingEngine["NORTH_EUROPE"] = "NORTH_EUROPE";
    eCountryGroupEuropeRatingEngine["SOUTH_EUROPE"] = "SOUTH_EUROPE";
    eCountryGroupEuropeRatingEngine["WEST_EUROPE"] = "WEST_EUROPE";
    eCountryGroupEuropeRatingEngine["EAST_EUROPE"] = "EAST_EUROPE";
    eCountryGroupEuropeRatingEngine["NORTH_AMERICA"] = "NORTH_AMERICA";
    eCountryGroupEuropeRatingEngine["SOUTH_AMERICA"] = "SOUTH_AMERICA";
    eCountryGroupEuropeRatingEngine["ASIA_1"] = "ASIA_1";
    eCountryGroupEuropeRatingEngine["ASIA_2"] = "ASIA_2";
    eCountryGroupEuropeRatingEngine["AFRICA_1"] = "AFRICA_1";
    eCountryGroupEuropeRatingEngine["OTHER"] = "OTHER";
    eCountryGroupEuropeRatingEngine["NOT_COVERED"] = "NOT_COVERED";
    eCountryGroupEuropeRatingEngine["SANCTIONED"] = "SANCTIONED";
})(eCountryGroupEuropeRatingEngine = exports.eCountryGroupEuropeRatingEngine || (exports.eCountryGroupEuropeRatingEngine = {}));
const getCountryAlpha2FromAlpha3 = (alpha3) => {
    const country = countries_json_1.default.find((c) => c.alpha3 === alpha3);
    return country === null || country === void 0 ? void 0 : country.alpha2;
};
exports.getCountryAlpha2FromAlpha3 = getCountryAlpha2FromAlpha3;
function postalRequired(countryCode) {
    return ["USA", "CAN", "GBR"].includes(countryCode);
}
exports.postalRequired = postalRequired;
const allCountries = countries_json_1.default.map((countyData) => new country_class_1.default(countyData.id, countyData.name, countyData.alpha2, countyData.alpha3, countyData.unCode, countyData.aliases, utils_1.getEnumKey("group", eCountryGroup, countyData.group), utils_1.getEnumKey("groupEuRatingEngine", eCountryGroupEuropeRatingEngine, countyData.groupEuRatingEngine)));
const getCountryAlpha3 = (country) => country.alpha3;
const getCountryId = (country) => country.id;
function getAllCountries() {
    return allCountries.filter(getCountryAlpha3);
}
exports.getAllCountries = getAllCountries;
function getAllCountryCodes() {
    return getAllCountries().map(getCountryAlpha3);
}
exports.getAllCountryCodes = getAllCountryCodes;
function getAllCoveredCountries() {
    return allCountries.filter((country) => country.group !== eCountryGroup.NOT_COVERED &&
        country.group !== eCountryGroup.SANCTIONED);
}
exports.getAllCoveredCountries = getAllCoveredCountries;
function getAllCoveredCountriesEURatingEngine() {
    return allCountries.filter((country) => country.groupEuRatingEngine !==
        eCountryGroupEuropeRatingEngine.NOT_COVERED &&
        country.groupEuRatingEngine !== eCountryGroupEuropeRatingEngine.SANCTIONED);
}
exports.getAllCoveredCountriesEURatingEngine = getAllCoveredCountriesEURatingEngine;
function getDefaultCountryCodes() {
    return ["USA"];
}
exports.getDefaultCountryCodes = getDefaultCountryCodes;
function getCountriesForGroup(...groups) {
    return allCountries.filter((country) => groups.includes(country.group));
}
exports.getCountriesForGroup = getCountriesForGroup;
function getCountriesForGroupEurope(...groups) {
    return allCountries.filter((country) => country.groupEuRatingEngine &&
        groups.includes(country.groupEuRatingEngine));
}
exports.getCountriesForGroupEurope = getCountriesForGroupEurope;
function getCountryIdentifiersForGroup(mapFn, groups, region = "USA") {
    if (region === "EUROPE") {
        return getCountriesForGroupEurope(...groups).map(mapFn);
    }
    return getCountriesForGroup(...groups).map(mapFn);
}
exports.getCountryIdentifiersForGroup = getCountryIdentifiersForGroup;
function getCountryIdsForGroup(groups, region = "USA") {
    return getCountryIdentifiersForGroup(getCountryId, groups, region);
}
exports.getCountryIdsForGroup = getCountryIdsForGroup;
function getCountryCodesForGroup(groups, region = "USA") {
    return getCountryIdentifiersForGroup(getCountryAlpha3, groups, region);
}
exports.getCountryCodesForGroup = getCountryCodesForGroup;
function getCountry(countryCode) {
    const country = allCountries.find((aCountry) => aCountry.id === countryCode ||
        aCountry.alpha2 === countryCode ||
        aCountry.alpha3 === countryCode);
    return country;
}
exports.getCountry = getCountry;
function getCountryIdentifiersForLocationsOrGroups(mapFn, locationsOrGroups, groupPrefix = "G:") {
    let countries = [];
    if (locationsOrGroups === null || locationsOrGroups === void 0 ? void 0 : locationsOrGroups.includes("G:ALL_COVERED")) {
        countries = getAllCoveredCountries();
    }
    else if (locationsOrGroups && locationsOrGroups.length) {
        const groups = locationsOrGroups
            .filter((location) => location.startsWith(groupPrefix))
            .map((location) => location.substring(groupPrefix.length));
        const countryIds = locationsOrGroups.filter((location) => !location.startsWith(groupPrefix));
        const groupingProperty = groupPrefix === "G:" ? "group" : "groupEuRatingEngine";
        countries = allCountries.filter((country) => {
            if (groups.some((group) => country[groupingProperty] === group)) {
                return true;
            }
            if (countryIds.some((id) => country.id === id)) {
                return true;
            }
            return false;
        });
    }
    const countryCodes = countries.map(mapFn);
    return countries
        .map(mapFn)
        .filter((code, index) => countryCodes.indexOf(code) === index);
}
exports.getCountryIdentifiersForLocationsOrGroups = getCountryIdentifiersForLocationsOrGroups;
function getCountryIdsForLocationsOrGroups(locationsOrGroups, groupPrefix = "G:") {
    return getCountryIdentifiersForLocationsOrGroups((country) => country.id, locationsOrGroups, groupPrefix);
}
exports.getCountryIdsForLocationsOrGroups = getCountryIdsForLocationsOrGroups;
function getCountryCodesForLocationsOrGroups(locationsOrGroups, groupPrefix = "G:") {
    return getCountryIdentifiersForLocationsOrGroups((country) => country.alpha3, locationsOrGroups, groupPrefix);
}
exports.getCountryCodesForLocationsOrGroups = getCountryCodesForLocationsOrGroups;
function getCountryGroup(countryCode, groupingProperty = "group") {
    const country = getCountry(countryCode);
    return country ? country[groupingProperty] : undefined;
}
exports.getCountryGroup = getCountryGroup;
function getCountryAlpha2(countryCode) {
    var _a;
    return (_a = getCountry(countryCode)) === null || _a === void 0 ? void 0 : _a.alpha2;
}
exports.getCountryAlpha2 = getCountryAlpha2;
function getCountryName(countryCode) {
    const country = allCountries.find((aCountry) => aCountry.id === countryCode ||
        aCountry.alpha2 === countryCode ||
        aCountry.alpha3 === countryCode);
    return country ? country.name : countryCode;
}
exports.getCountryName = getCountryName;
function getCountryCodes(locations) {
    const codes = locations.map((location) => location.substring(0, 3));
    return codes.filter((code, index) => codes.indexOf(code) === index);
}
exports.getCountryCodes = getCountryCodes;
function getCountryItems(countryOrCodes) {
    const items = countryOrCodes
        .map((countryOrCode) => {
        if (countryOrCode instanceof country_class_1.default) {
            return {
                value: countryOrCode.id,
                text: countryOrCode.name
            };
        }
        return {
            value: countryOrCode,
            text: getCountryName(countryOrCode)
        };
    })
        .sort(utils_1.compareItems);
    ["USA", "USA-CNTL", "CAN", "GBR", "USA-HI"].reverse().forEach((code) => {
        const idx = items.findIndex((country) => country.value === code);
        if (idx > 0) {
            const [country] = items.splice(idx, 1);
            items.unshift(country);
        }
    });
    return items;
}
exports.getCountryItems = getCountryItems;
function getAllCoveredCountryItems() {
    return getCountryItems(getAllCoveredCountries());
}
exports.getAllCoveredCountryItems = getAllCoveredCountryItems;
function getCountryCode(countryString) {
    const countryStringLowercase = countryString === null || countryString === void 0 ? void 0 : countryString.toLowerCase();
    if (countryStringLowercase) {
        const country = allCountries.find((aCountry) => aCountry.aliases.includes(countryStringLowercase));
        return country === null || country === void 0 ? void 0 : country.id;
    }
    return undefined;
}
exports.getCountryCode = getCountryCode;
function moveToTop(coutryItems, item) {
    const idx = coutryItems.findIndex((str) => str === item);
    if (idx > 0) {
        coutryItems.splice(idx, 1);
        coutryItems.unshift(item);
    }
    return coutryItems;
}
exports.moveToTop = moveToTop;
function getCountryCodesObject(countryList) {
    const countries = {};
    countryList.forEach(({ value, text }) => {
        countries[value] = text;
    });
    return countries;
}
exports.getCountryCodesObject = getCountryCodesObject;
const getCountryCodeExtendedFromAddress = (address) => {
    if ((address === null || address === void 0 ? void 0 : address.country) === "USA") {
        if ((address === null || address === void 0 ? void 0 : address.state) === "HI") {
            return "USA-HI";
        }
        return "USA-CNTL";
    }
    return address === null || address === void 0 ? void 0 : address.country;
};
exports.getCountryCodeExtendedFromAddress = getCountryCodeExtendedFromAddress;
function isEuropeanCountry(countryCode) {
    var _a;
    const group = (_a = getCountry(countryCode)) === null || _a === void 0 ? void 0 : _a.group;
    return group === eCountryGroup.EUROPE;
}
exports.isEuropeanCountry = isEuropeanCountry;
function getCountryItemsAlphabetic(countryOrCodes) {
    const items = countryOrCodes
        .map((countryOrCode) => {
        if (countryOrCode instanceof country_class_1.default) {
            return {
                value: countryOrCode.id,
                text: countryOrCode.name
            };
        }
        return {
            value: countryOrCode,
            text: getCountryName(countryOrCode)
        };
    })
        .sort(utils_1.compareItems);
    return items;
}
exports.getCountryItemsAlphabetic = getCountryItemsAlphabetic;
exports.default = country_class_1.default;
//# sourceMappingURL=index.js.map